import React from "react";

import "./styles.css";

function NoContent({ message }) {
  return <div className="no-content-wrapper">{message}</div>;
}

export default NoContent;
